import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../../assets/css/layouts/header.css";

import WLogo from "../../assets/img/WLogo.svg";
import BLogo from "../../assets/img/BLogo.svg";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 80);

    onScroll();

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "is-scrolled" : ""}`}>
      <div className="header-container">
        <Link to="/" className="header-logo-link" onClick={closeMenu}>
          <img src={WLogo} className="header-logo" alt="총학생회 로고" />
          <img src={BLogo} className="header-logo-rev" alt="총학생회 로고 반전" />
        </Link>

        <nav className={`header-nav ${menuOpen ? "is-open" : ""}`}>
          <NavLink to="/stdcouncil/council" onClick={closeMenu}>
            총학생회
          </NavLink>
          <NavLink to="/cc" onClick={closeMenu}>
            중앙운영위원회
          </NavLink>
          <NavLink to="/stdcouncil-log" onClick={closeMenu}>
            총학생회 활동
          </NavLink>
          <NavLink to="/documents" onClick={closeMenu}>
            자료실
          </NavLink>
          <NavLink to="/ask" onClick={closeMenu}>
            소통
          </NavLink>
        </nav>

        <div className="header-right">
          <button
            type="button"
            className={`mobile-menu-btn ${menuOpen ? "is-open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="모바일 메뉴"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}